import { GtmTracker } from '@/modules/common/services/analytics';
import { Categories } from '@/types/models/Analytics';

const trackAmplitudeEventPortfolio = GtmTracker.trackerWithDefaultProps({
  digital_experience: 'investor',
  experience_section: 'portfolio'
});

const trackEvent = GtmTracker.trackerWithDefaultProps({
  category: Categories.PEX
});

export function viewInvestmentSuggestionAmplitude() {
  trackAmplitudeEventPortfolio({
    page_screen: 'portfolio_investment_suggestion',
    event_type: 'load',
    event_name: 'view'
  });
}

export const walletDetail = (label: string) =>
  trackEvent({
    action: 'Clique selecionar carteira',
    label: `Sugestao de investimento - "${label}"`
  });

export function suggestedDetailsAmplitude(name: string) {
  trackAmplitudeEventPortfolio({
    page_screen: 'portfolio_investment_suggestion',
    event_type: 'click',
    page_screen_section: 'body',
    event_name: 'select_portfolio',
    event_target: name
  });
}
